/** @format */

const template = `
<div class="row">
  <div class="col-md-12">
    <ng-form name="{{::$ctrl.name}}">
      <input
        type="text"
        name="{{::$ctrl.name}}"
        class="form-control string-input"
        ng-pattern="$ctrl.pattern"
        ng-change="$ctrl.valueChanged()"
        ng-model-options="{ allowInvalid: true }"
        ng-model="$ctrl.ngModel.$viewValue"
        ng-required="$ctrl.required"
        ng-maxlength="$ctrl.maxLength"
        ng-minlength="$ctrl.minLength" />
    </ng-form>

    <ul
      class="error-list"
      ng-if="$ctrl.form[$ctrl.name].$invalid && !$ctrl.form[$ctrl.name].$pristine"
      ng-messages="$ctrl.form[$ctrl.name].$error"
      ng-messages-multiple="true"
      role="alert">
      <li ng-message="maxlength" translate translate-value-count="{{$ctrl.maxLength}}">SIS_COMPONENTS.STRING.CODE_EDITOR.TOO_LONG</li>

      <li ng-message="minlength" translate translate-value-count="{{$ctrl.minLength}}">SIS_COMPONENTS.STRING.CODE_EDITOR.TOO_SHORT</li>

      <li ng-message="required" translate>SIS_COMPONENTS.STRING.CODE_EDITOR.REQUIRED</li>

      <li ng-message="pattern" translate translate-value-pattern="{{$ctrl.pattern}}">SIS_COMPONENTS.STRING.CODE_EDITOR.PATTERN</li>
    </ul>
  </div>
</div>
`;
export default template;
